export default "__VITE_ASSET__WafH_LC1__"